"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const colors_1 = require("../colors");
const custom_1 = require("./custom");
exports.theme = custom_1.createThemeFromColor('#313142', 'dark-purple', 'Tím đậm', {
    override: {
        primaryBackgroundColor: colors_1.getStaticColors({ isDark: true }).purple,
    },
});
//# sourceMappingURL=dark-purple.js.map